import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

const Root = styled.div`
  align-items: center;
  border-radius: 100%;
  background-color: ${cbSemanticCssVars.borderPrimary};
  color: ${cbSemanticCssVars.textSecondary};
  display: flex;
  height: 25px;
  justify-content: center;
  width: 25px;
  flex-shrink: 0;
`;

const Content = styled(T.Body2)`
  font-weight: 600;
`;

type Props = {
  children: React.ReactNode;
};

const Ellipse = ({ children }: Props) => (
  <Root>
    <Content>{children}</Content>
  </Root>
);

export default Ellipse;
